import { serverTimestamp, setDoc } from "firebase/firestore";
import { getDb } from "@/lib/firebase/client";
import { paths, refDoc } from "./paths";

/**
 * Oznacza rozmowę Money Talk jako odbytą w danym tygodniu.
 * DocId = weekKey (YYYY-MM-DD poniedziałku) — naturalna idempotencja:
 * drugi klik w rodzinie nadpisuje doc tym samym kluczem, nie dubluje.
 * Rules: create dozwolony dla każdego członka HH, doc niemutowalny.
 */
export async function markMoneyTalkDone(input: {
  hid: string;
  weekKey: string;
  question: string;
  uid: string;
}): Promise<void> {
  const db = getDb();
  await setDoc(refDoc(db, paths.moneyTalk(input.hid, input.weekKey)), {
    weekKey: input.weekKey,
    question: input.question,
    markedBy: input.uid,
    markedAt: serverTimestamp(),
  });
}
